<!-- application quality index popup -->
<div id="forScroll" class="popup-bg popup-aqi-index ">
    <div class="popup">
        <div class="popup-content">
            <h3>{{listData.scoreName}}</h3>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>

            <a href="javascript:void(0)" class="delete-icon" (click)="forPopupClose()" >
                <img src="assets/images/close-light-icon.svg" alt="">
            </a>
            <form class="form-wrap" [formGroup]="editCard">
                <ng-container *ngIf="(cardName=='monitoring')">
                    <div class="input-row input-row-wide">
                        <div class="input-wrap">
                            <div class="type-text">
                                <span class="input-title">KPI Type <em> *</em></span>
                            </div>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType}">
                                <app-form-select-box [options]="globalService.kpiType" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="editCard" [controlName]="'kpiType_select_name'" [currentSelectedValue]="editCard['controls']['kpiType']['value']"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                        </div>
                        <div class="input-row">
                            <div class="input-wrap">
                                <div class="type-text">
                                <span class="input-title">KPI<em> *</em></span>
                            </div>
                                <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiList}">
                                    <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="editCard" [controlName]="'scoreName_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                        [currentSelectedValue]="editCard['controls']['scoreName']['value']">
                                    </app-form-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="input-row input-row-wide">
                        <div class="input-wrap" *ngIf="globalService.orderType=='app'">
                            <span class="input-title">Network</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="telcoArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'networks_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['networks']['value']">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="globalService.orderType=='telco'">
                            <span class="input-title">Apps</span>
                            <div class="dropdown-wrap">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiselectAppsList" formControlName="appNameArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>

                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">City</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.dropdownList}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList" formControlName="locationArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="location" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="editCard"
                                    [controlName]="'location_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['location']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['location'].errors?.required">
                                <sup>*</sup>Please enter your City
                            </div>
                        </div>
                    </div>
                    <div class="input-row input-row-wide">
                        <div class="input-wrap">
                            <span class="input-title">Speed</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectSpeed}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed" formControlName="networkTagArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networktag" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'networktag_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['networktag']['value']">
                                </app-form-select-box> -->
                            </div>

                        </div>
                        <div class="input-wrap">
                            <!-- <span class="calendar-icon"></span> -->
                            <span class="input-title">Date</span>
                            <!-- <ng-datepicker  name="date" [options]="options"></ng-datepicker> -->
                            <my-date-range-picker [placeholder]="'Select'" name="mydaterange" formControlName="model" [options]="myDateRangePickerOptions" required></my-date-range-picker>
                        </div>
                    </div>
                    <div class="input-row input-row-wide">
                        <div class="input-wrap">
                            <span class="input-title">Device</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectDeviceCategory}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory" formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="deviceCategory" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'deviceCategory_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['deviceCategory']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['deviceCategory'].errors?.required">
                                <sup>*</sup>Please enter your Device Category
                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="(cardName=='benchmarking')">
                            <span class="input-title">Choose Peers</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!peers}">
                                <app-form-select-box [options]="peers" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['peers']['value']">
                                </app-form-select-box>
                            </div>
                        </div>

                            <div class="input-wrap">
                                <!-- <span class="input-title">Stream Type</span>
                            <div class="dropdown-wrap">
                                <app-form-select-box [id]="'group_fk'" [options]="globalService.streamType"
                                    [dropDownIdKey]="'streamType_id'" [dropdownLabel]="'streamType'"
                                    [formElementName]="editCard" [controlName]="'streamType_select_name'"
                                    [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['streamType']['value']">
                                </app-form-select-box>
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['streamType'].errors?.required">
                                <sup>*</sup>Please enter your Stream Type
                            </div> -->
                                <span class="input-title">Choose Platform</span>
                                <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectPlatform}">
                                    <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectPlatform" formControlName="platformArray" [settings]="dropdownSettings">
                                    </ng-multiselect-dropdown>

                                </div>
                            </div>
                    </div>
                   
                </ng-container>
                <ng-container *ngIf="(cardName=='benchmarking')">
                    <div class="input-row input-row-wide">
                        <div class="input-wrap">
                            <div class="type-text">
                                <span class="input-title">KPI Type<em> *</em></span>
                            </div>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType}">
                                <app-form-select-box [options]="globalService.kpiType" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="editCard" [controlName]="'kpiType_select_name'" [currentSelectedValue]="editCard['controls']['kpiType']['value']"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                        </div>
                        <div class="input-row">
                            <div class="input-wrap">
                                <div class="type-text">
                                    <span class="input-title">KPI<em> *</em></span>
                                </div>
                                <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiList}">
                                    <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="editCard" [controlName]="'scoreName_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                        [currentSelectedValue]="editCard['controls']['scoreName']['value']">
                                    </app-form-select-box>
                                </div>
                            </div>
                        </div>
                        <div class="input-wrap">
                            
                            <span class="input-title">Choose Platform</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectPlatform}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectPlatform" formControlName="platformArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>

                            </div>
                        </div>
                    </div>
                    <div class="input-row input-row-wide">
                        <div class="input-wrap" *ngIf="globalService.orderType=='app'">
                            <span class="input-title">Network</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="telcoArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'networks_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['networks']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['networks'].errors?.required">
                                <sup>*</sup>Please enter your Device Category
                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="globalService.orderType=='telco'">
                            <span class="input-title">Apps</span>
                            <div class="dropdown-wrap">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiselectAppsList" formControlName="appNameArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>

                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">City</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.dropdownList}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList" formControlName="locationArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="location" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="editCard"
                                    [controlName]="'location_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['location']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['location'].errors?.required">
                                <sup>*</sup>Please enter your City
                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">Choose Peers</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!peers}">
                                <app-form-select-box [options]="peers" [isAllOptionShow]="true" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="editCard" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['peers']['value']">
                                </app-form-select-box>
                            </div>
                        </div>
                    </div>
                    <div class="input-row input-row-wide">
                        <div class="input-wrap">
                            <span class="input-title">Speed</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectSpeed}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed" formControlName="networkTagArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networktag" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'networktag_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['networktag']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['networktag'].errors?.required">
                                <sup>*</sup>Please enter your network speed
                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">Date</span>
                            <my-date-range-picker [placeholder]="'Select'" name="mydaterange" formControlName="model" [options]="myDateRangePickerOptions" required></my-date-range-picker>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">Device</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectDeviceCategory}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory" formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="deviceCategory" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="editCard"
                                    [controlName]="'deviceCategory_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)"
                                    [currentSelectedValue]="editCard['controls']['deviceCategory']['value']">
                                </app-form-select-box> -->
                            </div>
                            <div class="invalid-feedback" *ngIf="editCard['controls']['deviceCategory'].errors?.required">
                                <sup>*</sup>Please enter your Device Category
                            </div>
                        </div>
                    </div>
                   
                    
                </ng-container>
            </form>

        </div>
        <div class="popup-index">
            <h3>{{listData.scoreName}}</h3>
            <div class="aqi-indexing">
                <div class="index-left">
                    <span class="value" #cardValue [ngStyle]="{color:Card_color}">{{this.listData && this.listData['scoreName'] && this.listData['scoreName'].length > 0 && this.listData[this.listData['scoreName']] && (this.listData[this.listData['scoreName']].length > 0) && this.listData[this.listData['scoreName']][0]['value']   
                    ?this.listData[this.listData['scoreName']][0]['value'].toFixed(1):0}}</span>
                    <ul class="feature-list">
                        <ng-container *ngIf="kpiValueListArray && kpiValueListArray.length>0">
                            <li *ngFor="let score of kpiValueListArray;">
                                <span class="feature-title">{{score['name']}}</span>
                                <div class="feature-right">
                                    <span class="feature-title">{{score['value']?score['value'].toFixed(1):'-'}}</span>
                                    <div class="feature-info">
                                        <span class="info-icon" *ngIf="score['subScores'] && score['subScores'].length > 0"><img
                                                src="assets/images/info-icon.svg" alt=""></span>
                                        <!-- <ul class="feature-sublist" *ngIf ="score['subScores'] && score['subScores'].length > 0">
                                    <li *ngFor ="let subkpi of score['subScores'] "><span>{{subkpi['name']}}</span>
                                        <strong>{{subkpi['value']?subkpi['value'].toFixed(1):'-'}}</strong>
                                    </li>
                                </ul> -->
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="kpiValueListArray && kpiValueListArray.length==0">
                            <li>No Breakup</li>
                        </ng-container>
                    </ul>
                </div>
                <div class="index-right">
                    <div class="score-graph monitoring-legend">
                        <ng-container *ngIf="kpiValueListArray && kpiValueListArray.length>0">
                            <app-edit-card-graph [guageValue]="kpiValueListArray" [index]="'0'" [kpiScore]="listData.scoreName"></app-edit-card-graph>
                        </ng-container>
                        <ng-container *ngIf="kpiValueListArray && kpiValueListArray.length==0">
                            <span class="no-graph">No Graph</span>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="popup-links text-right">
                <!-- <button class="btn btn-light" (click)="forPopupClose()">close</button> -->
                <button class="btn btn-light" (click)="deleteCard()">delete</button>
                <button class="btn btn-dark" (click)="onSubmit()">add score</button>
            </div>
        </div>

    </div>
</div>